module.exports = __webpack_public_path__ + "img/cx.cd0b5887.svg";